import { put } from 'redux-saga/effects';
import * as actions from '../actions/index';
import axios from 'axios';

export function* tryFetchArticleSaga(action) {
    if (action.id) {
        try {
            const response = yield axios.get('https://0q8y1vgph9.execute-api.us-east-1.amazonaws.com/prod/posts/' + action.id, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': 'a7ILYWUgcQn69GcCLCnT9oZ57uPyR6v8HIH8oRLd',
                }
            });
            if (!response.status === 200) {
                yield put(actions.failFetchArticle());
            }
            const article = response.data.data;
            yield put(actions.successFetchArticle(article));
        } catch (error) {
            yield put(actions.failFetchArticle());
        }
    }
}